module.exports = __webpack_public_path__ + "static/media/consultoriaempresarial.51020fc5.jpg";